module.exports = __webpack_public_path__ + "img/icon_scoredent.41c2cc02.png";